import React from 'react';
import { Users, BookOpen, Star, Map } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="text-mint" size={24} data-id="element-263" />,
    text: '+300 nutris confían'
  }, {
    icon: <BookOpen className="text-mint" size={24} data-id="element-264" />,
    text: '5+ Tomos + Bonos'
  }, {
    icon: <Star className="text-mint" size={24} data-id="element-265" />,
    text: '4.9/5 calificación ⭐'
  }, {
    icon: <Map className="text-mint" size={24} data-id="element-266" />,
    text: '🇦🇷 Todo el país'
  }];
  return <div className="bg-surface text-white py-8 border-y border-mint/10" data-id="element-267">
      <div className="max-w-6xl mx-auto px-4" data-id="element-268">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x-0 md:divide-x divide-mint/20" data-id="element-269">
          {stats.map((stat, idx) => <div key={idx} className="flex flex-col items-center justify-center gap-2" data-id="element-270">
              {stat.icon}
              <span className="font-semibold text-sm md:text-base" data-id="element-271">
                {stat.text}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}